/**
 * domesticAirports.js — Single source of truth for India-domestic IATA codes.
 *
 * Sprint-5 · FLIGHT_SEARCH_RESULTS_COMPLETE_DEVELOPER_REPORT.md R2.
 * Previously HomePage and RoundTripResults each maintained a 33-code
 * subset, which was shorter than backend `INDIAN_AIRPORTS` (50 codes —
 * `tripjack_routes.py:767`). India-India routes through codes the FE
 * didn't know about (PAT, DED, IXM, DIU, RAJ etc.) silently fell through
 * to the Intl RT page or returned empty. This util mirrors the backend
 * set exactly so domestic detection is consistent end-to-end.
 *
 * Keep this file in sync with `backend/routes/tripjack_routes.py`
 * `INDIAN_AIRPORTS` set if the backend list ever grows.
 */
export const DOMESTIC_AIRPORTS = new Set([
  'DEL', 'BOM', 'BLR', 'MAA', 'CCU', 'HYD', 'AMD', 'COK', 'PNQ', 'GOI',
  'JAI', 'LKO', 'TRV', 'SXR', 'IXC', 'IXB', 'IXJ', 'IXR', 'IXZ', 'GAU',
  'PAT', 'VNS', 'AGR', 'ATQ', 'BDQ', 'DIB', 'DED', 'IXD', 'IXE', 'IXL',
  'IXM', 'IXU', 'IXW', 'JDH', 'JGA', 'JLR', 'JRH', 'JSA', 'KNU', 'NDC',
  'RPR', 'UDR', 'VGA', 'IXA', 'IXH', 'IMF', 'IXS', 'DIU', 'PBD', 'RAJ',
]);

export const isDomesticRoute = (fromCode, toCode) => {
  if (!fromCode || !toCode) return false;
  return DOMESTIC_AIRPORTS.has(String(fromCode).toUpperCase())
      && DOMESTIC_AIRPORTS.has(String(toCode).toUpperCase());
};
